import request from '@/utils/request'


//查询部门树
export function getDeptTree() {
  return request({
    method: 'get',
    url: "/organization/api/dept/tree"
  })
}
//获取角色列表
export function getRoleKv() {
  return request({
    method: 'get',
    url: "/organization/api/ga/all/user/role"
  })
}
//公安用户管理
export function getUserAll(data) {
  return request({
    method: 'post',
    url: "/organization/api/ga/user/all",
    data: data
  })
}
//  -- 公安添加用户
export function AddUser(data) {
  return request({
    method: 'post',
    url: "/organization/api/ga/user",
    data: data
  })
}
//  -- 公安修改用户
export function updateUser(data) {
  return request({
    method: 'post',
    url: "/organization/api/ga/user/edit",
    data: data
  })
}
//  -- 公安删除用户
export function deleteUser(id) {
  return request({
    method: 'post',
    url: "/organization/api/ga/user/delete/" + id
  })
}
//重置密码
export function resetPassword(id) {
  return request({
    method: 'post',
    url: "/organization/api/ga/refresh/password/" + id
  })
}
